import * as HLF from "html-living-framework";
import { AppProgress } from "../Data/AppProgress";
import * as Constants from "../Data/Constants";
import * as DressData from "../Data/DressData";
import { GalleryPaintableData } from "../Data/GalleryPaintableData";
import { GameType } from "../Data/GameData";
import * as VoiceOver from "../Data/VoiceOver";
import { PaintableDress } from "../GameObjects/PaintableDress";
import { GamePaintable } from "../States/GamePaintable";

export class GameDress extends GamePaintable {
    protected readonly _gameType = GameType.DRESS;
    protected readonly _colours: number[] = [
        (new HLF.Colour(255, 240, 77)).toHex(), // Yellow
        (new HLF.Colour(255, 162, 2)).toHex(), // Orange
        // (new HLF.Colour(255, 6, 0)).toHex(), // Red
        (new HLF.Colour(173, 255, 67)).toHex(), // Lime Green
        (new HLF.Colour(0, 175, 74)).toHex(), // Forest Green
        (new HLF.Colour(67, 221, 255)).toHex(), // Cyan
        (new HLF.Colour(32, 132, 254)).toHex(), // Blue
        (new HLF.Colour(227, 195, 14)).toHex(), // Yellow
        (new HLF.Colour(255, 119, 1)).toHex(), // Orange
        (new HLF.Colour(223, 37, 0)).toHex(), // Red
        (new HLF.Colour(14, 146, 1)).toHex(), // Green
        (new HLF.Colour(0, 50, 233)).toHex(), // Blue
        (new HLF.Colour(151, 177, 226)).toHex(), // Purple
        (new HLF.Colour(129, 64, 0)).toHex(), // Brown
        (new HLF.Colour(255, 255, 255)).toHex(), // White
        (new HLF.Colour(0, 0, 0)).toHex(), // Black
    ];

    constructor() {
        super();
        this._funFactCommon = VoiceOver.FUN_FACT_DRESS_COMMON;
        this._funFactUnique = VoiceOver.FUN_FACT_DRESS_UNIQUE;

        this._palette.setColours(this._colours);

        for (let i = 0; i < DressData.DATA.length; ++i) {
            this._paintables.push(new PaintableDress(i));
            const data: GalleryPaintableData = AppProgress.games[this._gameType].saveData[i] as GalleryPaintableData;
            if (data !== undefined) {
                for (let j = 0; j < data.sequence.length; ++j) {
                    this._paintables[i].layers[data.sequence[j]].paint(
                        data.colours[data.sequence[j]],
                        0, 0, true, true,
                    );
                }
            }
            this.addChild(this._paintables[i]);
            this.setChildIndex(this._paintables[i], 4);
        }

        HLF.PixiUtils.sendToFront(this._andy);
        HLF.PixiUtils.sendToFront(this._buttonSubmit);
        HLF.PixiUtils.sendToFront(this._buttonClear);
        HLF.PixiUtils.sendToFront(this._keyboardFocusManager);
    }

    public static getRequiredAssets(): string[] {
        const required = super.getRequiredAssets();
        for (let i = 0; i < DressData.DATA.length; ++i) {
            required.push(Constants.SPRITESHEET_DRESS_PREFIX + "0" + i + HLF.ResourceUtils.FILE_EXTENSION_JSON);
        }
        return required;
    }

    public init(pSize: PIXI.Point): void {
        super.init(pSize);

        if (this._isOnboarding === false) {
            this._activePaintableIndex = HLF.Random.intBetween(0, DressData.DATA.length);
            this._currentFunFactIndex = this._activePaintableIndex;
        }
        for (let i = 0; i < DressData.DATA.length; ++i) {
            this._paintables[i].visible = (i === this._activePaintableIndex);
        }
    }

    protected incrementIndex(pStep: number): void {
        super.incrementIndex(pStep);
        this._currentFunFactIndex = this._activePaintableIndex;
    }

    protected getAndyPos(): PIXI.Point {
        return new PIXI.Point(
            Math.max(this._size.x * 0.5 - this._andy.width * 0.5, 450),
            this._size.y * 0.5 + this._andy.height * 0.3,
        );
    }

    protected getFunFact(): string {
        // Since there are no common dress fun facts, we forcefully prevent the "firstVisit" behaviour and go
        // directly to playing unique fun facts
        if (this._isFirstVisit) {
            this._isFirstVisit = false;
        }
        return super.getFunFact();
    }
}
